import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileContactBar from "./MobileContactBar";
import CookieConsent from "./CookieConsent";
import SmoothScroll from "./SmoothScroll";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SmoothScroll />
      <Header />
      <main className="flex-1 pb-16 xl:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileContactBar />
      <CookieConsent />
    </div>
  );
}
